import { Invoke } from '@swf/components/StarsWizard/Flow';
import type { FlowConfig } from '@swf/core/types/Wizard';

import useRMFBaseSteps from '.././useRMFBaseSteps';
import RMFAddress from '../../components/RMFAddress/RMFAddress';
import RMFDepositLimit from '../../components/RMFDepositLimit/RMFDepositLimit';
import RMFLegalName from '../../components/RMFLegalName/RMFLegalName';
import RMFPhone from '../../components/RMFPhone/RMFPhone';
import RMFPlayerFundsProtection from '../../components/RMFPlayerFundsProtection/RMFPlayerFundsProtection';

import { Service } from './../useRmfServices';
import useRmfUKBaseSteps from './useRmfUKBaseSteps';

const useRmfUKPhoneAfterNameFlow = (): FlowConfig => {
  const { jumpToFeatureStep, forkDobCheck, invokeSignupDob } = useRMFBaseSteps();
  const {
    forkVerification,
    invokeRetryEnableRealMoneyFlag,
    invokeAddressSave,
    invokeDepositLimitSave,
    invokeEnableRealMoneyFlag,
    invokeUserDataSave,
    forkEKYCFailCheck,
    retryMarker
  } = useRmfUKBaseSteps();

  const invokeMobilePhoneSave = new Invoke(Service.RmfMobilePhoneSave, RMFAddress, RMFPhone);
  const invokeLegalNameSave = new Invoke(Service.RmfLegalNameSave, RMFPhone, RMFLegalName);

  return [
    invokeSignupDob,
    forkDobCheck,
    invokeLegalNameSave,
    RMFPhone,
    invokeMobilePhoneSave,
    RMFAddress,
    invokeAddressSave,
    RMFDepositLimit,
    invokeDepositLimitSave,
    RMFPlayerFundsProtection,
    invokeUserDataSave,
    invokeEnableRealMoneyFlag,
    retryMarker,
    forkEKYCFailCheck,
    invokeRetryEnableRealMoneyFlag,
    forkVerification,
    jumpToFeatureStep
  ];
};

export default useRmfUKPhoneAfterNameFlow;
